// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__rvnv0","modalForm":"UpgradeEpcsModal_modalForm__GxVbt","modalFooter":"UpgradeEpcsModal_modalFooter__1jk35"};